import React from 'react';

export const functionalPlusIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.9141 10.9883H12.9766V1.01172C12.9766 0.414062 12.5625 0 11.9609 0C11.3633 0 10.9492 0.414062 10.9492 1.01172V11.0234H1.01172C0.414062 10.9883 0 11.3984 0 12C0 12.6016 0.414062 13.0117 1.01172 13.0117H10.9883V23.0234C10.9883 23.625 11.3984 24.0391 12 24.0391C12.6016 24.0391 13.0117 23.625 13.0117 23.0234V12.9766H22.9883C23.5859 12.9766 24 12.5625 24 11.9609C23.9258 11.3984 23.5117 10.9883 22.9141 10.9883Z"
                fill="#173300"
            />
        </svg>
    );
};
